/**
 * I gruppi di righe duplicate che l'api rifiuta, tradotti nei **prodotti
 * locali** che li hanno prodotti.
 *
 * L'api non conosce i nostri prodotti: le righe dell'inventario portano
 * l'identita' di catalogo, e il rifiuto arriva quindi per **indice di riga**.
 * Chi ha costruito l'invio sa da quale prodotto viene ogni riga, e questa e' la
 * traduzione.
 *
 * Sta in un modulo e non dentro il modale per due ragioni: e' aritmetica sugli
 * indici, cioe' la cosa che sbaglia in silenzio — un fuori-range restituisce un
 * nome sbagliato invece di rompersi, e a schermo nessuno se ne accorge — e sul
 * client non c'e' un runner di test, quindi cio' che va provato deve essere
 * importabile da un harness.
 */

/**
 * @param {Array} duplicates i gruppi come li manda l'api:
 *        `{ lines: number[], product_reference_id, product_name, formulator_name }`
 * @param {Array} lineProducts i prodotti locali, nell'ordine in cui le righe
 *        sono state costruite
 * @returns {Array} `{ names: (string|null)[], productReferenceId, productName, formulatorName }`
 *          — `names` porta `null` dove il nome non si sa, e a decidere come
 *          scriverlo e' chi rende il testo, che ha le traduzioni
 */
export const duplicateGroupsFrom = (duplicates, lineProducts) =>
{
    if(!Array.isArray(duplicates)) return [];

    const products = Array.isArray(lineProducts) ? lineProducts : [];

    return duplicates.map( (group) => ({
        // `?? null` e non `?? ''`: un indice che non trova il suo prodotto e'
        // un nome **che non sappiamo**, e va detto come tale invece di
        // diventare una stringa vuota in mezzo all'elenco.
        names: (Array.isArray(group?.lines) ? group.lines : [])
            .map( (line) => products[line]?.name ?? null),
        productReferenceId: group?.product_reference_id ?? null,
        productName: group?.product_name ?? null,
        formulatorName: group?.formulator_name ?? null
    }));
};

export default duplicateGroupsFrom;
